import React from 'react';
import Card from 'react-bootstrap/Card';

class BillingIndianCustomer extends React.Component {
  render() {
    return (
        <>
            <div className="row pt-4">
              <div className="col-md-12">
              <Card>
                <Card.Header className="billing-card-header">For Indian Customers Only</Card.Header>
                <Card.Body>
                  <Card.Text>
                  To Pay Via Credit Card / UPI / Cash Call <a href="tel:+91-8104797220">+91-8104797220</a> or Email <a href="mailto:care@orggenteam.com">care@orggenteam.com</a>.
                  </Card.Text>
                </Card.Body>
              </Card>
              </div>
            </div>
        </>
    );
  }
}
export default BillingIndianCustomer;
